import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface SavedAccount {
  id: string // = userId
  displayName: string
  username?: string
  avatarUrl?: string
  accessToken: string
  refreshToken: string
}

interface AccountsState {
  accounts: SavedAccount[]
  activeAccountId: string | null

  saveAccount: (account: SavedAccount) => void
  removeAccount: (id: string) => void
  setActiveAccount: (id: string) => void
}

export const useAccountsStore = create<AccountsState>()(
  persist(
    (set) => ({
      accounts: [],
      activeAccountId: null,

      saveAccount: (account) =>
        set((s) => ({
          accounts: s.accounts.some((a) => a.id === account.id)
            ? s.accounts.map((a) => (a.id === account.id ? account : a))
            : [...s.accounts, account],
          activeAccountId: account.id,
        })),

      removeAccount: (id) =>
        set((s) => ({
          accounts: s.accounts.filter((a) => a.id !== id),
          activeAccountId: s.activeAccountId === id
            ? (s.accounts.find((a) => a.id !== id)?.id ?? null)
            : s.activeAccountId,
        })),

      setActiveAccount: (id) => set({ activeAccountId: id }),
    }),
    { name: 'ggram-accounts' },
  ),
)
